'use client'
import { SxProps, Typography, styled } from '@mui/material'
import React from 'react'
import { colors } from '../../Theme/LegacyTheme'

interface HeadingWithAnchorProps {
  title: string
  centerHeader?: boolean
  styleOverrides?: SxProps
  sectionId?: string
}

const HeadingBlock = styled('div')(() => ({
  '& > h2 > a': {
    color: colors.black,
    textDecoration: 'underline'
  }
}))

const HeadingWithAnchor: React.FC<HeadingWithAnchorProps> = ({
  title,
  centerHeader,
  styleOverrides,
  sectionId
}) => {
  return (
    <HeadingBlock sx={{ ...styleOverrides }} id={sectionId}>
      <Typography
        variant="h2"
        className={[centerHeader ? 'text-center' : ''].join(' ')}
        data-testid="heading-block-title"
      >
        <a href={`#${sectionId}`}>{title}</a>
      </Typography>
    </HeadingBlock>
  )
}

export default HeadingWithAnchor
